/**
 * @prop --stzh-pi-menu-padding-left
 */

:host {
  --padding-left: var(--stzh-pi-menu-padding-left, #{$containerMargin});
  --trigger-size: #{iconSize(large)};
  --trigger-color: #{$colorBlack};
  --content-background: #{$colorPrimary20};
  --icon-size: #{iconSize()};
  --button-color: #{$colorBlack};
  --button-background-color: #{$colorPrimary30};

  --hover-button-color: var(--button-color);
  --hover-button-background-color: #{$colorPrimary40};
  --hover-trigger-color: var(--trigger-color);

  @media print {
    page-break-inside: avoid;
    break-inside: avoid;
  }

  @include highContrast() {
    --trigger-color: CanvasText;

    --hover-trigger-color: CanvasText;
  }
}

.stzh-pi-menu {
  height: 100%;
  transition: width 0.15s ease;
  width: 100%;
  z-index: 1;
  position: absolute;


  /* Scrollbar styling */

  &::-webkit-scrollbar {
    width: 8px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: var(--stzh-color-primary30);
  }

  &::-webkit-scrollbar-track {
    background: var(--content-background);
  }

  scrollbar-color: var(--stzh-color-primary30) var(--content-background);


  &--fixed {
    position: fixed;
    top: 0;
    height: auto;
  }

  &__heading {
    margin: 0;
    position: sticky;
    top: 0;
  }

  &__backdrop {
    position: absolute;
    z-index: -1;
    top: 0;
    width: 0;
    height: 0;
    background-color: $colorBlack40op;
    opacity: 0;
    transition: opacity $baseTransitionAnimationSpeed;
    pointer-events: none;

    &--visible {
      width: 100vw;
      height: 100vh;
      opacity: 1;
      pointer-events: auto;
    }
  }

  &__button {
    @include fontSize('centi');
    @include font('heavy');
    @include spaceCurve('padding-top', 'regular');
    @include spaceCurve('padding-bottom', 'regular');
    width: 100%;
    min-height: 56px;
    appearance: none;
    display: flex;
    align-items: center;
    gap: var(--stzh-space-xsmall);
    color: var(--button-color);
    background-color: var(--button-background-color);
    text-align: left;
    border: none;
    transition-property: background-color;
    transition-duration: $baseTransitionAnimationSpeed;
    cursor: pointer;

    @include mq($from: large) {
      @include fontSize('deci');
    }

    @media (prefers-reduced-motion: reduce) {
      transition: none;
    }

    &:hover {
      color: var(--hover-button-color);
      background-color: var(--hover-button-background-color);
    }
  }

  &__button-spacer {
    visibility: hidden;
    pointer-events: none;
  }

  &__subheading {
    @include fontSize('centi');
    @include font('heavy');
    margin: 0;
    @include spaceCurve('padding-top', 'small');
    @include spaceCurve('padding-bottom', 'tiny');
    hyphens: auto;

    @include mq($from: large) {
      @include fontSize('deci');
    }
  }

  &__button,
  &__subheading {
    padding-left: var(--padding-left);
    @include spaceCurve('padding-right', 'regular');
  }

  &__content-inner {
    background-color: var(--content-background);
    overflow-y: hidden;
  }

  &__button-text {
    flex-grow: 1;
    display: none;

    @include mq($from: small) {
      display: inherit;
    }
  }

  &__button-icon {
    --size: var(--trigger-size);

    transition-property: transform, color;
    transition-duration: 500ms;
    color: var(--trigger-color);

    @media (prefers-reduced-motion: reduce) {
      transition: none;
    }
  }

  &__button:hover &__button-icon {
    &.is-default {
      &::before,
      &::after {
        background-color: var(--hover-trigger-color);
      }
    }

    color: var(--hover-trigger-color);
  }

  &__content {
    height: 100%;
    width: 100%;
    @media print {
      height: auto !important;
      overflow: visible !important;
      display: block !important;
    }
  }

  &__heading-text {
    display: block;
  }

  /* Nav */

  &__nav {
    padding-bottom: var(--stzh-space-xlarge);
  }

  &__nav-list {
    list-style: none;
    margin-block-start: 0;
    margin-block-end: 0;
    padding-inline-start: 0;
  }

  &__nav-item {
    display: block;
    @include spaceCurve('padding-top', 'tiny');
    @include spaceCurve('padding-right', 'regular');
    @include spaceCurve('padding-bottom', 'tiny');
    padding-left: var(--padding-left);
    text-decoration: none;
    color: var(--stzh-color-black);

    &:hover {
      color: var(--stzh-color-primary70);
    }
  }

  &__nav-item.active {
    background-color: var(--stzh-color-primary30);
  }

  &__nav-item.is-level-1 {
    @include font('heavy');
  }

  &__nav-item.is-level-2 {
    padding-left: calc(var(--padding-left) + var(--stzh-space-xlarge));
  }

  &__button-space-helper {
    visibility: hidden;
    pointer-events: none;
  }


  /* Open */

  &--is-open {
    .stzh-pi-menu__button-icon {
      transform: rotate(180deg);
    }

    .stzh-pi-menu__content-inner {
      overflow-y: scroll;
      height: calc(100vh - 64px);

      @include mq($from: small) {
        height: calc(100vh - 72px);
      }

      @include mq($from: medium) {
        height: calc(100vh - 80px);
      }

      @include mq($from: medium) {
        height: calc(100vh - 96px);
      }
    }
  }
}
